var map = {
	"./sparkle-1.svg": "4d50",
	"./sparkle-2.svg": "0c32",
	"./sparkle-3.svg": "15db",
	"./sparkle-4.svg": "c9cb",
	"./sparkle-5.svg": "7cfd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a738";